import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import ReportGenerationPage from "./pages/ReportGenerationPage";
import ReportsOverviewPage from "./pages/ReportsOverviewPage";

function App() {
	return (
		<AuthProvider>
			<BrowserRouter basename="/">
				<Routes>
					{/* Login page - redirect to report generation if already authenticated */}
					<Route path="/login" element={<LoginPage />} />
					{/* Protected routes */}
					<Route
						path="/"
						element={
							<ProtectedRoute>
								<Navigate to="/report" replace />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/report"
						element={
							<ProtectedRoute>
								<ReportGenerationPage />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/reports"
						element={
							<ProtectedRoute>
								<ReportsOverviewPage />
							</ProtectedRoute>
						}
					/>

					{/* Catch all - redirect to login */}
					<Route path="*" element={<Navigate to="/login" replace />} />
				</Routes>
			</BrowserRouter>
		</AuthProvider>
	);
}

export default App;
